import { Observable } from "rxjs";
import { Patient } from "../patient-chart/patient";

export default class ActivityGridItem {
  id: number;
  firstName: string;
  lastName: string;
  activityType: string;
  patientChartId: number;
  mileage: number;
  activityDate: string;
  disciplines: string;
  patientChart$: Observable<Patient>;
  duration: string;

  get fullName(): string {
    return this.lastName + ", " + this.firstName;
  }
}

export interface ActivityResource {
  userId: number;
  userName: string;
  userFullName: string;
}

export interface DisciplineActivity {
  code: string;
  displayName: string;
}



// WEBPACK FOOTER //
// ./src/models/company-resources/activity-grid.ts